/* eslint-disable */
// @ts-nocheck
// source: internal/info_gathering.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.worklayer.internal.v1.Checklist', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetChecklistRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RequestedSupportingItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Section', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput.Document', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput.Notes', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.SupportingItemInput.TypeCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetChecklistRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetChecklistRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetChecklistRequest.displayName = 'proto.worklayer.internal.v1.GetChecklistRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Checklist = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Checklist.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Checklist, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Checklist.displayName = 'proto.worklayer.internal.v1.Checklist';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Section = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Section.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Section, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Section.displayName = 'proto.worklayer.internal.v1.Section';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RequestedSupportingItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RequestedSupportingItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RequestedSupportingItem.displayName = 'proto.worklayer.internal.v1.RequestedSupportingItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SupportingItemInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.v1.SupportingItemInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SupportingItemInput.displayName = 'proto.worklayer.internal.v1.SupportingItemInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SupportingItemInput.Document = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.SupportingItemInput.Document.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.SupportingItemInput.Document, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SupportingItemInput.Document.displayName = 'proto.worklayer.internal.v1.SupportingItemInput.Document';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.displayName = 'proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.displayName = 'proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.displayName = 'proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.displayName = 'proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.displayName = 'proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.displayName = 'proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.displayName = 'proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.SupportingItemInput.Notes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.SupportingItemInput.Notes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.SupportingItemInput.Notes.displayName = 'proto.worklayer.internal.v1.SupportingItemInput.Notes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.displayName = 'proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.displayName = 'proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.displayName = 'proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.displayName = 'proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.displayName = 'proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.displayName = 'proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetChecklistRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetChecklistRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetChecklistRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetChecklistRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetChecklistRequest}
 */
proto.worklayer.internal.v1.GetChecklistRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetChecklistRequest;
  return proto.worklayer.internal.v1.GetChecklistRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetChecklistRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetChecklistRequest}
 */
proto.worklayer.internal.v1.GetChecklistRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetChecklistRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetChecklistRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetChecklistRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetChecklistRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetChecklistRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetChecklistRequest} returns this
 */
proto.worklayer.internal.v1.GetChecklistRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Checklist.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Checklist.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Checklist.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Checklist} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Checklist.toObject = function(includeInstance, msg) {
  var f, obj = {
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.worklayer.internal.v1.Section.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Checklist}
 */
proto.worklayer.internal.v1.Checklist.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Checklist;
  return proto.worklayer.internal.v1.Checklist.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Checklist} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Checklist}
 */
proto.worklayer.internal.v1.Checklist.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.Section;
      reader.readMessage(value,proto.worklayer.internal.v1.Section.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Checklist.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Checklist.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Checklist} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Checklist.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.Section.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Section sections = 1;
 * @return {!Array<!proto.worklayer.internal.v1.Section>}
 */
proto.worklayer.internal.v1.Checklist.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Section>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Section, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Section>} value
 * @return {!proto.worklayer.internal.v1.Checklist} returns this
*/
proto.worklayer.internal.v1.Checklist.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Section=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Section}
 */
proto.worklayer.internal.v1.Checklist.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.Section, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Checklist} returns this
 */
proto.worklayer.internal.v1.Checklist.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Section.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Section.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Section.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Section} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Section.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    heading: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    requestedSupportingItemsList: jspb.Message.toObjectList(msg.getRequestedSupportingItemsList(),
    proto.worklayer.internal.v1.RequestedSupportingItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Section}
 */
proto.worklayer.internal.v1.Section.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Section;
  return proto.worklayer.internal.v1.Section.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Section} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Section}
 */
proto.worklayer.internal.v1.Section.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeading(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.RequestedSupportingItem;
      reader.readMessage(value,proto.worklayer.internal.v1.RequestedSupportingItem.deserializeBinaryFromReader);
      msg.addRequestedSupportingItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Section.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Section.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Section} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Section.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHeading();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRequestedSupportingItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.worklayer.internal.v1.RequestedSupportingItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Section.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Section} returns this
 */
proto.worklayer.internal.v1.Section.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Section.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Section} returns this
 */
proto.worklayer.internal.v1.Section.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string heading = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.Section.prototype.getHeading = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Section} returns this
 */
proto.worklayer.internal.v1.Section.prototype.setHeading = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.Section.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Section} returns this
 */
proto.worklayer.internal.v1.Section.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated RequestedSupportingItem requested_supporting_items = 5;
 * @return {!Array<!proto.worklayer.internal.v1.RequestedSupportingItem>}
 */
proto.worklayer.internal.v1.Section.prototype.getRequestedSupportingItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.RequestedSupportingItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.RequestedSupportingItem, 5));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.RequestedSupportingItem>} value
 * @return {!proto.worklayer.internal.v1.Section} returns this
*/
proto.worklayer.internal.v1.Section.prototype.setRequestedSupportingItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.worklayer.internal.v1.RequestedSupportingItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem}
 */
proto.worklayer.internal.v1.Section.prototype.addRequestedSupportingItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.worklayer.internal.v1.RequestedSupportingItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Section} returns this
 */
proto.worklayer.internal.v1.Section.prototype.clearRequestedSupportingItemsList = function() {
  return this.setRequestedSupportingItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RequestedSupportingItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RequestedSupportingItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RequestedSupportingItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    heading: jspb.Message.getFieldWithDefault(msg, 3, ""),
    shortDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
    longDescription: jspb.Message.getFieldWithDefault(msg, 5, ""),
    imageUrl: (f = msg.getImageUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    previewUrl: (f = msg.getPreviewUrl()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    required: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    completed: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    input: (f = msg.getInput()) && proto.worklayer.internal.v1.SupportingItemInput.toObject(includeInstance, f),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    adHoc: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RequestedSupportingItem;
  return proto.worklayer.internal.v1.RequestedSupportingItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RequestedSupportingItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeading(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongDescription(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setImageUrl(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPreviewUrl(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequired(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleted(value);
      break;
    case 10:
      var value = new proto.worklayer.internal.v1.SupportingItemInput;
      reader.readMessage(value,proto.worklayer.internal.v1.SupportingItemInput.deserializeBinaryFromReader);
      msg.setInput(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdHoc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RequestedSupportingItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RequestedSupportingItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RequestedSupportingItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHeading();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getShortDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLongDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getImageUrl();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPreviewUrl();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRequired();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getCompleted();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getInput();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.worklayer.internal.v1.SupportingItemInput.serializeBinaryToWriter
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAdHoc();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string heading = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getHeading = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setHeading = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string short_description = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getShortDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setShortDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string long_description = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getLongDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setLongDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.StringValue image_url = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getImageUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
*/
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setImageUrl = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.clearImageUrl = function() {
  return this.setImageUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.hasImageUrl = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue preview_url = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getPreviewUrl = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
*/
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setPreviewUrl = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.clearPreviewUrl = function() {
  return this.setPreviewUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.hasPreviewUrl = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool required = 8;
 * @return {boolean}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool completed = 9;
 * @return {boolean}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional SupportingItemInput input = 10;
 * @return {?proto.worklayer.internal.v1.SupportingItemInput}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getInput = function() {
  return /** @type{?proto.worklayer.internal.v1.SupportingItemInput} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SupportingItemInput, 10));
};


/**
 * @param {?proto.worklayer.internal.v1.SupportingItemInput|undefined} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
*/
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setInput = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.clearInput = function() {
  return this.setInput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.hasInput = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp update_time = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
*/
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool ad_hoc = 12;
 * @return {boolean}
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.getAdHoc = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItem} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItem.prototype.setAdHoc = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.SupportingItemInput.TypeCase = {
  TYPE_NOT_SET: 0,
  DOCUMENT: 1,
  PERSONAL_INFO: 2,
  SPOUSAL_INFO: 3,
  DEPENDENTS_INFO: 4,
  PERSONAL_REFUND_METHOD: 5,
  BUSINESS_INFO: 6,
  BUSINESS_REFUND_METHOD: 7,
  NOTES: 8
};

/**
 * @return {proto.worklayer.internal.v1.SupportingItemInput.TypeCase}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.getTypeCase = function() {
  return /** @type {proto.worklayer.internal.v1.SupportingItemInput.TypeCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SupportingItemInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SupportingItemInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    document: (f = msg.getDocument()) && proto.worklayer.internal.v1.SupportingItemInput.Document.toObject(includeInstance, f),
    personalInfo: (f = msg.getPersonalInfo()) && proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.toObject(includeInstance, f),
    spousalInfo: (f = msg.getSpousalInfo()) && proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.toObject(includeInstance, f),
    dependentsInfo: (f = msg.getDependentsInfo()) && proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.toObject(includeInstance, f),
    personalRefundMethod: (f = msg.getPersonalRefundMethod()) && proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.toObject(includeInstance, f),
    businessInfo: (f = msg.getBusinessInfo()) && proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.toObject(includeInstance, f),
    businessRefundMethod: (f = msg.getBusinessRefundMethod()) && proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.toObject(includeInstance, f),
    notes: (f = msg.getNotes()) && proto.worklayer.internal.v1.SupportingItemInput.Notes.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput}
 */
proto.worklayer.internal.v1.SupportingItemInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SupportingItemInput;
  return proto.worklayer.internal.v1.SupportingItemInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput}
 */
proto.worklayer.internal.v1.SupportingItemInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.SupportingItemInput.Document;
      reader.readMessage(value,proto.worklayer.internal.v1.SupportingItemInput.Document.deserializeBinaryFromReader);
      msg.setDocument(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.deserializeBinaryFromReader);
      msg.setPersonalInfo(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.deserializeBinaryFromReader);
      msg.setSpousalInfo(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.deserializeBinaryFromReader);
      msg.setDependentsInfo(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod;
      reader.readMessage(value,proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.deserializeBinaryFromReader);
      msg.setPersonalRefundMethod(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo;
      reader.readMessage(value,proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.deserializeBinaryFromReader);
      msg.setBusinessInfo(value);
      break;
    case 7:
      var value = new proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod;
      reader.readMessage(value,proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.deserializeBinaryFromReader);
      msg.setBusinessRefundMethod(value);
      break;
    case 8:
      var value = new proto.worklayer.internal.v1.SupportingItemInput.Notes;
      reader.readMessage(value,proto.worklayer.internal.v1.SupportingItemInput.Notes.deserializeBinaryFromReader);
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SupportingItemInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocument();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.v1.SupportingItemInput.Document.serializeBinaryToWriter
    );
  }
  f = message.getPersonalInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.serializeBinaryToWriter
    );
  }
  f = message.getSpousalInfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.serializeBinaryToWriter
    );
  }
  f = message.getDependentsInfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.serializeBinaryToWriter
    );
  }
  f = message.getPersonalRefundMethod();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.serializeBinaryToWriter
    );
  }
  f = message.getBusinessInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.serializeBinaryToWriter
    );
  }
  f = message.getBusinessRefundMethod();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.serializeBinaryToWriter
    );
  }
  f = message.getNotes();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.worklayer.internal.v1.SupportingItemInput.Notes.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SupportingItemInput.Document.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.Document} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentTypeShortId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    documentIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.Document}
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SupportingItemInput.Document;
  return proto.worklayer.internal.v1.SupportingItemInput.Document.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.Document} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.Document}
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentTypeShortId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addDocumentIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SupportingItemInput.Document.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.Document} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentTypeShortId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocumentIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string document_type_short_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.prototype.getDocumentTypeShortId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.Document} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.prototype.setDocumentTypeShortId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string document_ids = 2;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.prototype.getDocumentIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.Document} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.prototype.setDocumentIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.Document} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.prototype.addDocumentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.Document} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.Document.prototype.clearDocumentIdsList = function() {
  return this.setDocumentIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    profileId: (f = msg.getProfileId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    profileVersion: (f = msg.getProfileVersion()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo;
  return proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfileId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setProfileVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfileId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getProfileVersion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue profile_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.prototype.getProfileId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.prototype.setProfileId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.prototype.clearProfileId = function() {
  return this.setProfileId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.prototype.hasProfileId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int32Value profile_version = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.prototype.getProfileVersion = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.prototype.setProfileVersion = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.prototype.clearProfileVersion = function() {
  return this.setProfileVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo.prototype.hasProfileVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    profileId: (f = msg.getProfileId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    profileVersion: (f = msg.getProfileVersion()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo;
  return proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfileId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setProfileVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfileId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getProfileVersion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue profile_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.prototype.getProfileId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.prototype.setProfileId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.prototype.clearProfileId = function() {
  return this.setProfileId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.prototype.hasProfileId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int32Value profile_version = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.prototype.getProfileVersion = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.prototype.setProfileVersion = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.prototype.clearProfileVersion = function() {
  return this.setProfileVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo.prototype.hasProfileVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    dependentsList: jspb.Message.toObjectList(msg.getDependentsList(),
    proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo;
  return proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent;
      reader.readMessage(value,proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.deserializeBinaryFromReader);
      msg.addDependents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDependentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.toObject = function(includeInstance, msg) {
  var f, obj = {
    profileId: (f = msg.getProfileId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    profileVersion: (f = msg.getProfileVersion()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent;
  return proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfileId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setProfileVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfileId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getProfileVersion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue profile_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.prototype.getProfileId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.prototype.setProfileId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.prototype.clearProfileId = function() {
  return this.setProfileId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.prototype.hasProfileId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int32Value profile_version = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.prototype.getProfileVersion = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.prototype.setProfileVersion = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.prototype.clearProfileVersion = function() {
  return this.setProfileVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent.prototype.hasProfileVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated ProvidedDependent dependents = 1;
 * @return {!Array<!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent>}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.prototype.getDependentsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent>} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.prototype.setDependentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent}
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.prototype.addDependents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.ProvidedDependent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo.prototype.clearDependentsList = function() {
  return this.setDependentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    refundMethodId: (f = msg.getRefundMethodId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    refundMethodVersion: (f = msg.getRefundMethodVersion()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod;
  return proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRefundMethodId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRefundMethodVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRefundMethodId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRefundMethodVersion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue refund_method_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.prototype.getRefundMethodId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.prototype.setRefundMethodId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.prototype.clearRefundMethodId = function() {
  return this.setRefundMethodId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.prototype.hasRefundMethodId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int32Value refund_method_version = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.prototype.getRefundMethodVersion = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.prototype.setRefundMethodVersion = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.prototype.clearRefundMethodVersion = function() {
  return this.setRefundMethodVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod.prototype.hasRefundMethodVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    profileId: (f = msg.getProfileId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    profileVersion: (f = msg.getProfileVersion()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo;
  return proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setProfileId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setProfileVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfileId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getProfileVersion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue profile_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.prototype.getProfileId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.prototype.setProfileId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.prototype.clearProfileId = function() {
  return this.setProfileId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.prototype.hasProfileId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int32Value profile_version = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.prototype.getProfileVersion = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.prototype.setProfileVersion = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.prototype.clearProfileVersion = function() {
  return this.setProfileVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo.prototype.hasProfileVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    refundMethodId: (f = msg.getRefundMethodId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    refundMethodVersion: (f = msg.getRefundMethodVersion()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod;
  return proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setRefundMethodId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setRefundMethodVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRefundMethodId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getRefundMethodVersion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue refund_method_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.prototype.getRefundMethodId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.prototype.setRefundMethodId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.prototype.clearRefundMethodId = function() {
  return this.setRefundMethodId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.prototype.hasRefundMethodId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int32Value refund_method_version = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.prototype.getRefundMethodVersion = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.prototype.setRefundMethodVersion = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.prototype.clearRefundMethodVersion = function() {
  return this.setRefundMethodVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod.prototype.hasRefundMethodVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.SupportingItemInput.Notes.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.SupportingItemInput.Notes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.Notes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.Notes.toObject = function(includeInstance, msg) {
  var f, obj = {
    text: (f = msg.getText()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.Notes}
 */
proto.worklayer.internal.v1.SupportingItemInput.Notes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.SupportingItemInput.Notes;
  return proto.worklayer.internal.v1.SupportingItemInput.Notes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.Notes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.Notes}
 */
proto.worklayer.internal.v1.SupportingItemInput.Notes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.SupportingItemInput.Notes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.SupportingItemInput.Notes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.SupportingItemInput.Notes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.SupportingItemInput.Notes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getText();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue text = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.SupportingItemInput.Notes.prototype.getText = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.Notes} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.Notes.prototype.setText = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput.Notes} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.Notes.prototype.clearText = function() {
  return this.setText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.Notes.prototype.hasText = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Document document = 1;
 * @return {?proto.worklayer.internal.v1.SupportingItemInput.Document}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.getDocument = function() {
  return /** @type{?proto.worklayer.internal.v1.SupportingItemInput.Document} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SupportingItemInput.Document, 1));
};


/**
 * @param {?proto.worklayer.internal.v1.SupportingItemInput.Document|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.prototype.setDocument = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.clearDocument = function() {
  return this.setDocument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.hasDocument = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PersonalInfo personal_info = 2;
 * @return {?proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.getPersonalInfo = function() {
  return /** @type{?proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.SupportingItemInput.PersonalInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.prototype.setPersonalInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.clearPersonalInfo = function() {
  return this.setPersonalInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.hasPersonalInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SpousalInfo spousal_info = 3;
 * @return {?proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.getSpousalInfo = function() {
  return /** @type{?proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.SupportingItemInput.SpousalInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.prototype.setSpousalInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.clearSpousalInfo = function() {
  return this.setSpousalInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.hasSpousalInfo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional DependentsInfo dependents_info = 4;
 * @return {?proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.getDependentsInfo = function() {
  return /** @type{?proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.SupportingItemInput.DependentsInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.prototype.setDependentsInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.clearDependentsInfo = function() {
  return this.setDependentsInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.hasDependentsInfo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PersonalRefundMethod personal_refund_method = 5;
 * @return {?proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.getPersonalRefundMethod = function() {
  return /** @type{?proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.SupportingItemInput.PersonalRefundMethod|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.prototype.setPersonalRefundMethod = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.clearPersonalRefundMethod = function() {
  return this.setPersonalRefundMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.hasPersonalRefundMethod = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional BusinessInfo business_info = 6;
 * @return {?proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.getBusinessInfo = function() {
  return /** @type{?proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo, 6));
};


/**
 * @param {?proto.worklayer.internal.v1.SupportingItemInput.BusinessInfo|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.prototype.setBusinessInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.clearBusinessInfo = function() {
  return this.setBusinessInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.hasBusinessInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional BusinessRefundMethod business_refund_method = 7;
 * @return {?proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.getBusinessRefundMethod = function() {
  return /** @type{?proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod, 7));
};


/**
 * @param {?proto.worklayer.internal.v1.SupportingItemInput.BusinessRefundMethod|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.prototype.setBusinessRefundMethod = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.clearBusinessRefundMethod = function() {
  return this.setBusinessRefundMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.hasBusinessRefundMethod = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Notes notes = 8;
 * @return {?proto.worklayer.internal.v1.SupportingItemInput.Notes}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.getNotes = function() {
  return /** @type{?proto.worklayer.internal.v1.SupportingItemInput.Notes} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.SupportingItemInput.Notes, 8));
};


/**
 * @param {?proto.worklayer.internal.v1.SupportingItemInput.Notes|undefined} value
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
*/
proto.worklayer.internal.v1.SupportingItemInput.prototype.setNotes = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.worklayer.internal.v1.SupportingItemInput.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.SupportingItemInput} returns this
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.clearNotes = function() {
  return this.setNotes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.SupportingItemInput.prototype.hasNotes = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    documentId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest;
  return proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDocumentId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string document_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentRequest.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse;
  return proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemDocumentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    documentId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest;
  return proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocumentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest} returns this
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string document_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest} returns this
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentRequest.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse;
  return proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingItemDocumentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    profileVersion: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest;
  return proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProfileVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProfileVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string profile_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.prototype.getProfileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.prototype.setProfileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 profile_version = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.prototype.getProfileVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoRequest.prototype.setProfileVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse;
  return proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    profileVersion: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest;
  return proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProfileVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProfileVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string profile_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.prototype.getProfileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.prototype.setProfileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 profile_version = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.prototype.getProfileVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoRequest.prototype.setProfileVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse;
  return proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemDependentInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest;
  return proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest} returns this
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest} returns this
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string profile_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.prototype.getProfileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest} returns this
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoRequest.prototype.setProfileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse;
  return proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RemoveSupportingItemDependentInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    profileVersion: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest;
  return proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProfileVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProfileVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string profile_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.prototype.getProfileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.prototype.setProfileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 profile_version = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.prototype.getProfileVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoRequest.prototype.setProfileVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse;
  return proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemSpousalInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    refundMethodId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    refundMethodVersion: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest;
  return proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefundMethodId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRefundMethodVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRefundMethodId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRefundMethodVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string refund_method_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.prototype.getRefundMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.prototype.setRefundMethodId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 refund_method_version = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.prototype.getRefundMethodVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodRequest.prototype.setRefundMethodVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse;
  return proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemPersonalRefundMethodResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    refundMethodId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    refundMethodVersion: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest;
  return proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefundMethodId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRefundMethodVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRefundMethodId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRefundMethodVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string refund_method_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.prototype.getRefundMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.prototype.setRefundMethodId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 refund_method_version = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.prototype.getRefundMethodVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodRequest.prototype.setRefundMethodVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse;
  return proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessRefundMethodResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    profileVersion: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest;
  return proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProfileVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProfileVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string profile_id = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.prototype.getProfileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.prototype.setProfileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 profile_version = 4;
 * @return {number}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.prototype.getProfileVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoRequest.prototype.setProfileVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse;
  return proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemBusinessInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    requestedSupportingItem: (f = msg.getRequestedSupportingItem()) && proto.worklayer.internal.v1.RequestedSupportingItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent;
  return proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent}
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.RequestedSupportingItem;
      reader.readMessage(value,proto.worklayer.internal.v1.RequestedSupportingItem.deserializeBinaryFromReader);
      msg.setRequestedSupportingItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRequestedSupportingItem();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.RequestedSupportingItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RequestedSupportingItem requested_supporting_item = 2;
 * @return {?proto.worklayer.internal.v1.RequestedSupportingItem}
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.prototype.getRequestedSupportingItem = function() {
  return /** @type{?proto.worklayer.internal.v1.RequestedSupportingItem} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.RequestedSupportingItem, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.RequestedSupportingItem|undefined} value
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent} returns this
*/
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.prototype.setRequestedSupportingItem = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.prototype.clearRequestedSupportingItem = function() {
  return this.setRequestedSupportingItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.RequestedSupportingItemUpdatedRealtimeEvent.prototype.hasRequestedSupportingItem = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    notes: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest;
  return proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string notes = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest} returns this
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse;
  return proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ProvideSupportingItemNotesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.worklayer.internal.v1);
